const title = 'Hear.com | Partner Portal'

export { title as appTitle }
